export default "__VITE_ASSET__DN8ioY3E__"